import { useEffect, useState } from "react";
import { MessageCircle, Mail, Phone, MapPin } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Contact() {
  const [whatsapp, setWhatsapp] = useState("");
  useEffect(() => {
    api.get("/config").then(({ data }) => setWhatsapp(data.whatsapp_number)).catch(() => {});
  }, []);

  const display = whatsapp ? `+${whatsapp}` : "";

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="font-head text-4xl font-extrabold text-primary mb-2">Contactez-nous</h1>
      <p className="text-muted-foreground mb-8">Nous sommes à votre écoute pour organiser votre voyage et vos démarches.</p>

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl soft-shadow border border-gray-100 p-6">
          <div className="h-12 w-12 rounded-xl bg-[#25D366]/15 flex items-center justify-center mb-4">
            <MessageCircle className="h-6 w-6 text-[#25D366]" />
          </div>
          <h2 className="font-head font-bold text-lg text-primary mb-1">WhatsApp</h2>
          <p className="text-muted-foreground text-sm mb-4">La façon la plus rapide de nous joindre.</p>
          {whatsapp && (
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-btn">
              <Button className="rounded-full bg-[#25D366] hover:bg-[#1da851] text-white font-bold">Écrire sur WhatsApp</Button>
            </a>
          )}
        </div>

        <div className="bg-white rounded-2xl soft-shadow border border-gray-100 p-6 space-y-4">
          <div className="flex items-center gap-3">
            <Phone className="h-5 w-5 text-accent" />
            <span className="text-primary font-medium" data-testid="contact-phone">{display}</span>
          </div>
          <div className="flex items-center gap-3">
            <Mail className="h-5 w-5 text-accent" />
            <span className="text-primary font-medium">contact@worldtravel.cm</span>
          </div>
          <div className="flex items-center gap-3">
            <MapPin className="h-5 w-5 text-accent" />
            <span className="text-primary font-medium">Cameroun</span>
          </div>
        </div>
      </div>
    </div>
  );
}
